<template>
  <div class="spinner-container text-center">
    <b-spinner></b-spinner>
  </div>
</template>

<script>
export default {
  name: 'LoadingSpinner',
};
</script>
